import { COLORS } from './colors';
export const themeTypography = {
    typography: {
        fontFamily: {
            primary: 'Open Sans, sans-serif',
            secondary: 'Inter, sans-serif',
            special: 'Montserrat',
        },
        fontWeight: {
            200: '200',
            400: '400',
            600: '600',
            700: '700',
        },
        fontSize: {
            xl: '1em',
            l: '0.8em',
            m: '0.75em',
            s: '0.7em',
            xs: '0.6em',
        },
    },
};
export const commonThemeData = {
    shape: {
        borderRadius: {
            l: '10px',
            m: '8px',
            s: '4px',
        },
    },
    transitionDuration: {
        normal: '0.3s',
    },
    spacing: (value = 1) => `${value * 8}px`,
};
export const defaultPalette = {
    palette: {
        error: COLORS.red,
        online: COLORS.green[40],
        background: {
            primary: COLORS.grey[15],
            secondary: COLORS.grey[10],
            hightLight: COLORS.grey[5],
            popup: COLORS.grey[70],
        },
        border: {
            primary: COLORS.grey[15],
            shadow: COLORS.grey[70],
            popup: COLORS.grey[40],
        },
        text: {
            primary: COLORS.grey[70],
            secondary: COLORS.grey[20],
            hightLight: COLORS.grey[0],
            special: COLORS.grey[40],
            popup: COLORS.grey[5],
        },
    },
};
